import {
    RULES_FAILURE,
    RULES_REQUEST,
    RULES_SUCCESS,
    RULES_POST_SUCCESS,
    RULES_COPY_SUCCESS,
    RULES_PATCH_SUCCESS,
    RULE_CATEGORIES_POST_SUCCESS, RULE_CATEGORY_DELETE_SUCCESS, RULE_CATEGORY_GROUP_SUCCESS,
    RULE_CATEGORY_PATCH_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
    /*
     * WHICH ruleset `data` holds, or null for all of them.
     *
     * The collection is 1.9 MB and `/competitions` reads the ONE ruleset its
     * competition uses, so `isFetched` alone would tell the settings screens
     * the list is complete when it holds one of 31. A consumer that needs them
     * all checks this first — the same contract the participants slice already
     * uses for competitions.
     */
    fetchedRule: null,
};

export const ruleListReducer = (state = initialState, action) => {
    const {type, data, rule, ruleCategory, categories, group} = action;
    switch (type) {
        case RULE_CATEGORIES_POST_SUCCESS: {
            return {
                ...state,
                data: state.data.map(r => r.id !== rule ? r : {
                    ...r,
                    ruleCategories: [...r.ruleCategories, ruleCategory],
                }),
            }
        }

        case RULE_CATEGORY_DELETE_SUCCESS: {
            return {
                ...state,
                data: state.data.map(r => r.id !== rule ? r : {
                    ...r,
                    ruleCategories: r.ruleCategories.filter(c => c.id !== ruleCategory),
                }),
            }
        }

        case RULE_CATEGORY_PATCH_SUCCESS: {
            return {
                ...state,
                data: state.data.map(r => r.id !== rule ? r : {
                    ...r,
                    ruleCategories: [
                        ...r.ruleCategories.filter(c => c.id !== ruleCategory.id),
                        ruleCategory
                    ],
                }),
            }
        }

        /*
         * A BULK GROUP ASSIGNMENT — rewritten in place.
         *
         * Unlike RULE_CATEGORY_PATCH_SUCCESS above, which drops the category
         * and re-appends it, this maps over the list: the set can be the whole
         * ruleset, and moving 297 categories to the end would reorder the
         * screen out from under the organiser who is reading it.
         */
        case RULE_CATEGORY_GROUP_SUCCESS: {
            const changed = new Set(categories);
            return {
                ...state,
                data: state.data.map(r => r.id !== rule ? r : {
                    ...r,
                    ruleCategories: r.ruleCategories.map(c =>
                        changed.has(c.id) ? { ...c, categoryGroup: group } : c
                    ),
                }),
            }
        }

        case RULES_PATCH_SUCCESS: {
            return {
                ...state,
                data: state.data.map(r =>
                    r.id !== rule.id ? r : { ...r, ...rule, ruleCategories: r.ruleCategories }
                ),
            }
        }

        case RULES_POST_SUCCESS:
        case RULES_COPY_SUCCESS: {
            return {
                ...state,
                data: [...state.data, rule]
            }
        }

        case RULES_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            fetchedRule: action.rule || null,
            data: preserveArrayReference(state.data, data),
        }}

        case RULES_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case RULES_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
